/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Budget_MaxInputs */

const cs_requirements_budget_max = /** @type {(inputs: Requirements_Budget_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpočet do`)
};

const en_requirements_budget_max = /** @type {(inputs: Requirements_Budget_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget max`)
};

/**
* | output |
* | --- |
* | "Budget max" |
*
* @param {Requirements_Budget_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_budget_max = /** @type {((inputs?: Requirements_Budget_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Budget_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_budget_max(inputs)
	return cs_requirements_budget_max(inputs)
});